import { render, staticRenderFns } from "./xitongMess.vue?vue&type=template&id=4f26ba2b&scoped=true"
import script from "./xitongMess.vue?vue&type=script&lang=js"
export * from "./xitongMess.vue?vue&type=script&lang=js"
import style0 from "./xitongMess.vue?vue&type=style&index=0&id=4f26ba2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f26ba2b",
  null
  
)

export default component.exports